import {
    useTemporalWorkflowStatus,
    UseTemporalWorkflowStatusOptions,
} from './useTemporalWorkflowStatus'

/**
 * Specialized hook for mint ordinal workflow status updates.
 * This is a convenience wrapper around the generic useTemporalWorkflowStatus hook
 * with mint-ordinal-specific configuration.
 */
export function useMintOrdinalWorkflowStatus(
    workflowId: string | null,
    runId: string | null,
    options: Omit<
        UseTemporalWorkflowStatusOptions,
        'eventBusTopic' | 'completionKeywords' | 'logPrefix'
    > = { enabled: false },
) {
    return useTemporalWorkflowStatus(
        workflowId,
        runId,
        'progress',
        'AppTemporal::Workflows::MintOrdinalWorkflow',
        {
            ...options,
            eventBusTopic: 'mint_ordinal_status',
            completionKeywords: ['successfully!', 'completed', 'Ordinal minted successfully'],
            logPrefix: 'Minting',
        },
    )
}
